import * as env from 'src/lib/env';
import type { DeviceType } from 'src/lib/userAgent';

import { openOAuthPopup } from './utils';

const AUTH_URL = `${env.getBackendUrl()}/authentication/google_oauth2`;

const formatGoogleSignupUrl = (state: string, signUpDevice: DeviceType) =>
  AUTH_URL.concat('?state=', encodeURIComponent(state), '&signUpDevice=', signUpDevice);

export const loginToGoogle = (state: string, signUpDevice: DeviceType) => {
  const authUrl = formatGoogleSignupUrl(state, signUpDevice);

  return openOAuthPopup(authUrl);
};
